import React, { Component } from 'react'
import './style.css'
import { Table, Card, Row, Col, Image } from 'react-bootstrap'
import FeedbackViewModal from '../Feedback/FeedbackViewModal'
import ReactPaginate from 'react-paginate'
var dateFormat = require('dateformat');

class Feedback extends Component {
    constructor(props) {
        super(props)
        this.state = {
            perPage: 10,
            currentPage: 0,
            page: 1,
            Spage: 1,
            searchId: '',
            perPageS: 10,
            searchQuery: '',
            feedbkShow: false,
            showSerch: false,
            showTable: false

        }

        this.SearchOnChange = this.SearchOnChange.bind(this)
    }
    componentDidMount() {
        this.props.feedbkList()
        // this.props.slectedPage()

    }

    handleFeedbkView = (item) => {
        this.setState({
            feedbkShow: true,
            feedbkDtls: item
        })
    }

    handleCloseFeedbk = () => {
        this.setState({ feedbkShow: false })
    }


    handlePageClick = (e) => {
        const selectedPage = e.selected + 1;

        this.props.slectedPage(selectedPage)
        this.setState({ page: selectedPage })
    };

    // SearchOnChange = event => {
    //     console.log("search event---------->",event.target.value)
    //     let user = event.target.value
    //     this.props.feedbackSearch(user) 
    //   }

    SearchOnChange = event => {

        let user = event.target.value


        this.props.searchUser(user)
        this.setState({
            showSerch: true,
            searchQuery: user
        })
        if (event.target.value.length === 0) {
            this.setState({
                showSerch: false,
                showTable: false,
                Spage: 1

            })
        }
    }
    selectUsrSubmit(value) {

        this.setState({
            showSerch: false,
            searchQuery: value.name,
            searchId: value.id
        })
        this.props.fetchFeedbckById({
            id: value.id,
            Spage: this.state.Spage
        })
        this.setState({ showTable: true })
    }
    handlePageSearchClick = (e) => {

        const selectedSearchPage = e.selected + 1;

        this.setState({ Spage: selectedSearchPage })
        let Sdata = {
            id: this.state.searchId,
            Spage: selectedSearchPage,
            searchQuery: this.state.searchQuery
        }

        this.props.feedbackPagitn(Sdata)

    };
    render() {
        // console.log("feedbk details-----", this.props.FeedBckSearchCount)
        let p = this.state.page

        const count = this.props.fedbckDtlsCount && this.props.fedbckDtlsCount
        let fdbkPageCount = Math.ceil(count / this.state.perPage)

        let p2 = this.state.Spage
        const SearchCount = this.props.FeedBckSearchCount && this.props.FeedBckSearchCount
        const SearchPageCount = Math.ceil(SearchCount / this.state.perPageS)
        return (
            <div>
                <Card>
                    <Card.Header>
                        <Row>
                            <Col xs={12} sm={6} md={4} lg={4} style={{ margin: "auto" }}>
                                <h3>Feedback</h3>
                            </Col>
                            <Col xs={12} sm={6} md={4} lg={4}>
                                <div className="userInput">
                                    <i className="fa fa-search fa-lg userIcon"></i>
                                    <input
                                        type="text"
                                        placeholder="Search by Name"
                                        value={this.state.searchQuery}
                                        onChange={this.SearchOnChange}

                                    />
                                    {this.state.showSerch && this.props.UsersList && <div className="userSrchList">
                                        {this.state.showSerch && this.props.UsersList && this.props.UsersList.map((item, key) => (
                                            <button
                                                key={key}
                                                className="btnStylefleet"
                                                onClick={() =>
                                                    this.selectUsrSubmit(
                                                        item
                                                    )}
                                            >
                                                <div>
                                                    <div className="blockOnefleet">

                                                    </div>
                                                    <div className="blockTwofleet">
                                                        <div className="blockTxtOnefleet">
                                                            {item.name}
                                                        </div>
                                                        <div className="blockTxtTwofleet">
                                                            {item.mobileNo}
                                                        </div>
                                                    </div>
                                                </div>
                                            </button>
                                        ))}
                                    </div>}
                                </div>
                            </Col>




                            <Col xs={12} sm={6} md={4} lg={4}>

                                <div className="totalRecord">
                                    <i className="cui-note icons" style={{ fontSize: "15px" }}></i>
                                    <span style={{ padding: "5px", fontWeight: 600, fontSize: "18px", opacity: ".7" }}>
                                        {count !== 0 && count !== undefined ? count : 0}</span>
                                    <span style={{ opacity: ".7" }}>Results</span>
                                </div>

                            </Col>
                        </Row>
                    </Card.Header>
                    <Card.Body>
                        {!this.state.showTable &&
                            <div>
                                <Table
                                    responsive
                                    bordered
                                    striped
                                    className="feedbkTable"
                                >
                                    <thead >
                                        <tr>
                                            <th style={{ width: "70px" }}>SL NO</th>
                                            <th>FEEDBACK BY</th>
                                            <th>FEEDBACK FOR</th>
                                            <th style={{ width: "150px" }}>CREATED DATE</th>
                                            <th>FEEDBACK</th>
                                            <th style={{ width: "90px" }}>RATING</th>
                                            <th style={{ width: "100px" }}>ACTION</th>

                                        </tr>
                                    </thead>
                                    <tbody>


                                        {this.props.fedbckDtlsList && this.props.fedbckDtlsList.map((item, i) => (
                                            <tr key={i}>
                                                <td >{10 * (p - 1) + i + 1}</td>
                                                <td className="feedbackCap">
                                                    {item.userId !== null && item.userId.name}
                                                </td>
                                                <td className="feedbackCap">
                                                    {item.orgId !== null && item.orgId.name}
                                                </td>
                                                <td className="feedbackCap">{item.createdAt !== null && dateFormat(item.createdAt, "mediumDate")}</td>
                                                <td className="feedbackCap feedbkDesc">
                                                    {item.feedback !== null && item.feedback}
                                                </td>
                                                <td className="feedbackCap">{item.rating !== null && item.rating}</td>
                                                <td className="feedbackViewIcon">
                                                    <div>
                                                        <i className="fa fa-eye fa-lg "
                                                            onClick={() =>
                                                                this.handleFeedbkView({ item: item })
                                                            }
                                                        ></i>
                                                        <FeedbackViewModal
                                                            show={this.state.feedbkShow}
                                                            handleClose={this.handleCloseFeedbk}
                                                            feedbkDtls={this.state.feedbkDtls}
                                                        />
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}



                                    </tbody>
                                </Table>


                                {
                                    (this.props.fedbckDtlsList === undefined || (this.props.fedbckDtlsList && this.props.fedbckDtlsList.length === 0)) && (

                                        <div>
                                            <div className="noDataImgDiv">
                                                <Image
                                                    className="noDataImg"
                                                    src={require('../../assets/img/nodata4.png')}
                                                />
                                            </div>
                                            <div className="noDataTextDiv">
                                                No Feedbacks Found
                                      </div>
                                        </div>
                                    )}

                            </div>
                        }
                        {this.state.showTable &&
                            <div>
                                <Table
                                    responsive
                                    bordered
                                    striped
                                    className="feedbkTable"
                                >
                                    <thead >
                                        <tr>
                                            <th style={{ width: "70px" }}>SL NO</th>
                                            <th>FEEDBACK BY</th>
                                            <th>FEEDBACK FOR</th>
                                            <th style={{ width: "150px" }}>CREATED DATE</th>
                                            <th>FEEDBACK</th>
                                            <th style={{ width: "90px" }}>RATING</th>
                                            <th style={{ width: "100px" }}>ACTION</th>

                                        </tr>
                                    </thead>
                                    <tbody>


                                        {this.props.FeedBckSearchList && this.props.FeedBckSearchList.map((item, i) => (
                                            <tr key={i}>
                                                <td >{10 * (p2 - 1) + i + 1}</td>
                                                <td className="feedbackCap">
                                                    {item.userId !== null && item.userId.name}
                                                </td>
                                                <td className="feedbackCap">
                                                    {item.orgId !== null && item.orgId.name}
                                                </td>
                                                <td className="feedbackCap">{item.createdAt !== null && dateFormat(item.createdAt, "mediumDate")}</td>
                                                <td className="feedbackCap feedbkDesc">
                                                    {item.feedback !== null && item.feedback}
                                                </td>
                                                <td className="feedbackCap">{item.rating !== null && item.rating}</td>
                                                <td className="feedbackViewIcon">
                                                    <div>
                                                        <i className="fa fa-eye fa-lg "
                                                            onClick={() =>
                                                                this.handleFeedbkView({ item: item })
                                                            }
                                                        ></i>
                                                        <FeedbackViewModal
                                                            show={this.state.feedbkShow}
                                                            handleClose={this.handleCloseFeedbk}
                                                            feedbkDtls={this.state.feedbkDtls}
                                                        />
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}



                                    </tbody>
                                </Table>


                                {
                                    (this.props.FeedBckSearchList === undefined || (this.props.FeedBckSearchList && this.props.FeedBckSearchList.length === 0)) && (

                                        <div>
                                            <div className="noDataImgDiv">
                                                <Image
                                                    className="noDataImg"
                                                    src={require('../../assets/img/nodata4.png')}
                                                />
                                            </div>
                                            <div className="noDataTextDiv">
                                                No Feedbacks Found
                                      </div>
                                        </div>
                                    )}

                            </div>
                        }
                    </Card.Body>

                    {!this.state.showTable && fdbkPageCount && fdbkPageCount > 1 ? (

                        <div className="paginationDiv">

                            <ReactPaginate
                                previousLabel={"Prev"}
                                nextLabel={"Next"}
                                breakLabel={"..."}
                                breakClassName={"break-me"}
                                pageCount={fdbkPageCount}
                                marginPagesDisplayed={2}
                                pageRangeDisplayed={5}
                                onPageChange={this.handlePageClick}
                                containerClassName={"pagination flex-wrap"}
                                subContainerClassName={"pages pagination"}
                                activeClassName={"active"} />
                        </div>

                    ) : null}
                    {this.state.showTable &&
                        SearchPageCount && SearchPageCount > 1 ? (
                            <div className="paginationDiv">

                                <ReactPaginate
                                    previousLabel={"Prev"}
                                    nextLabel={"Next"}
                                    breakLabel={"..."}
                                    breakClassName={"break-me"}
                                    pageCount={SearchPageCount}
                                    marginPagesDisplayed={2}
                                    pageRangeDisplayed={5}
                                    onPageChange={this.handlePageSearchClick}
                                    containerClassName={"pagination flex-wrap"}
                                    subContainerClassName={"pages pagination"}
                                    activeClassName={"active"} />
                            </div>
                        ) : null
                    }

                </Card>
            </div>
        )
    }
}

export default Feedback